// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this to your CSS file */
.statistic-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  border-top: 1.8px solid #004999 !important;
  border-radius: 15px;
  border-left: 1.8px solid #004999 !important;
}

.statistic-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.hover-lift:hover {
  transform: translateY(-3px);
}

/* .bg-card {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: center right;
  opacity: 0.1;
  z-index: 0;
} */

.card-body {
  position: relative;
  z-index: 1;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .display-4 {
    font-size: 1.75rem;
  }
}


/* Custom CSS for improved design */
.stock-alerts-card,
.recent-activity-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stock-alerts-card:hover,
.recent-activity-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.badge-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.badge-warning {
  background-color: #fff3cd;
  color: #856404;
}

.bg-gradient-primary {
  background: #004086;
}

.bg-gradient-info {
  background: #004086;
}

.icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.activity-timeline .activity-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 29px;
  top: 55px;
  bottom: -10px;
  width: 2px;
  background-color: #e9ecef;
}

.timeline-connector {
  position: absolute;
  left: 29px;
  top: 55px;
  bottom: -10px;
  width: 2px;
  background-color: #e9ecef;
  z-index: 1;
}

.table> :not(caption)>*>* {
  padding: 0.75rem 0.5rem;
}

.rounded-top-3 {
  border-top-left-radius: 0.75rem !important;
  border-top-right-radius: 0.75rem !important;
}

.borderv1 {
  border: 1.3px solid #4b94cd !important;
  border-radius: 50% !important;
  padding: 0px !important;
}

.card-scroll {
  max-height: 400px;
  /* adjust height */
  overflow-y: auto;
  overflow-x: hidden;
}

.activity-timeline {
  padding-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/dash.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;AACF;;;AAGA,mCAAmC;AACnC;;EAEE,qDAAqD;AACvD;;AAEA;;EAEE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Add this to your CSS file */\n.statistic-card {\n  transition: all 0.3s ease;\n  border-radius: 12px;\n  overflow: hidden;\n  border-top: 1.8px solid #004999 !important;\n  border-radius: 15px;\n  border-left: 1.8px solid #004999 !important;\n}\n\n.statistic-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;\n}\n\n.hover-lift:hover {\n  transform: translateY(-3px);\n}\n\n/* .bg-card {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-size: cover;\n  background-position: center right;\n  opacity: 0.1;\n  z-index: 0;\n} */\n\n.card-body {\n  position: relative;\n  z-index: 1;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .display-4 {\n    font-size: 1.75rem;\n  }\n}\n\n\n/* Custom CSS for improved design */\n.stock-alerts-card,\n.recent-activity-card {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stock-alerts-card:hover,\n.recent-activity-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n}\n\n.status-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.badge-danger {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.badge-warning {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.bg-gradient-primary {\n  background: #004086;\n}\n\n.bg-gradient-info {\n  background: #004086;\n}\n\n.icon-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.activity-timeline .activity-item:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  left: 29px;\n  top: 55px;\n  bottom: -10px;\n  width: 2px;\n  background-color: #e9ecef;\n}\n\n.timeline-connector {\n  position: absolute;\n  left: 29px;\n  top: 55px;\n  bottom: -10px;\n  width: 2px;\n  background-color: #e9ecef;\n  z-index: 1;\n}\n\n.table> :not(caption)>*>* {\n  padding: 0.75rem 0.5rem;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: 0.75rem !important;\n  border-top-right-radius: 0.75rem !important;\n}\n\n.borderv1 {\n  border: 1.3px solid #4b94cd !important;\n  border-radius: 50% !important;\n  padding: 0px !important;\n}\n\n.card-scroll {\n  max-height: 400px;\n  /* adjust height */\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.activity-timeline {\n  padding-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
